export default "__VITE_ASSET__DQZ8ueeK__"